<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <svg-icon
          v-if="item.meta && item.meta.icon"
          :icon-class="item.meta.icon"
          class="app-breadcrumb__icon"
        ></svg-icon>
        <span
          v-if="item.redirect === 'noredirect' || index == levelList.length - 1"
          class="no-redirect"
        >
          {{ item.meta.title }}
        </span>
        <router-link v-else :to="item.redirect || item.path">
          {{ item.meta.title }}
        </router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: null
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  methods: {
    getBreadcrumb() {
      const matched = this.$route.matched.filter((item) => {
        return item.meta && item.meta.title;
      });
      this.levelList = matched.length > 1 ? matched.slice(0, -1) : [];
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--shell-text-muted, #6c7d92);

  .app-breadcrumb__icon {
    margin-right: 6px;
    color: #5e86b8;
    font-size: 14px;
  }

  .el-breadcrumb__inner,
  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    display: inline-flex;
    align-items: center;
    color: inherit !important;
    font-size: 13px;
    font-weight: 500 !important;
  }

  ::v-deep .el-breadcrumb__separator {
    margin: 0 10px;
    color: rgba(108, 125, 146, 0.42);
    font-size: 12px;
  }

  .no-redirect {
    color: var(--shell-text-primary, #1d2b3d);
    font-weight: 600;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue